module.exports = __webpack_public_path__ + "static/media/angle-double-down.8a66268d.svg";